import { Grid, Typography } from "@mui/material";
import { GridColDef } from "@mui/x-data-grid";
import { StatusCell } from "components/atoms";
import { AppTable } from "components/molecules";
import { ColorHelper, StatusHelper, TableHelper, TimeHelper } from "helpers";
import { EPrepareStatus, IPaginateApiResponse, IPrepare } from "model";
import { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { useHistory, useLocation } from "react-router-dom";
import { PrepareActions } from "redux/actions";
import { useAppSelector } from "redux/configurations/reduxHooks";
import i18n, { I18nTranslator, _t, translations } from "utils/i18n";

const PrepareDocument = () => {
  const dispatch = useDispatch();
  const history = useHistory();
  const location = useLocation();
  const pathname = location.pathname;
  const [searchText, setSearchText] = useState("");

  const onCellClick = (params: any) => {
    history.push(`${pathname}/${params.row.id}&${params.row.prepareCode}`);
  };
  const data = useAppSelector(
    (state) => state.PrepareReducer.prepare
  ) as IPaginateApiResponse<any>;
  const action = useAppSelector((state) => state.PrepareReducer.action);

  useEffect(() => {
    _getAllPrepareDocuments();
  }, [searchText]);

  const _getAllPrepareDocuments = (pageNumber = 1) => {
    dispatch(
      PrepareActions.getAllPrepareDocuments.request({
        pageNumber: pageNumber,
        pageSize: 100,
        searchText: searchText,
      })
    );
  };

  const COLUMNS: GridColDef[] = [
    TableHelper.renderSTT(),
    TableHelper.createCell({
      field: "prepareCode",
      headerName: I18nTranslator(translations.receive.documentId),
      size: "small",
      align: "left",
    }),
    TableHelper.createCell({
      field: "doImportCode",
      headerName: I18nTranslator(translations.receive.loCode),
      size: "small",
      align: "left",
    }),
    TableHelper.createCell({
      field: "companyCode",
      headerName: I18nTranslator(translations.receive.companyId),
      size: "small",
      align: "left",
    }),
    TableHelper.createCell({
      field: "companyName",
      headerName: I18nTranslator(translations.receive.companyName),
      size: "medium",
      align: "left",
    }),
    TableHelper.createCell({
      field: "province",
      headerName: I18nTranslator(translations.receive.address),
      size: "medium",
      align: "left",
    }),

    TableHelper.createCell({
      field: "status",
      headerName: I18nTranslator(translations.status),
      align: "left",
      size: "medium",
      renderCell: ({ value }) => (
        <StatusCell
          bgcolor={ColorHelper.getPrepareStatusColor(value as EPrepareStatus)}
        >
          {StatusHelper.getPrepareStatusString(value)}
        </StatusCell>
      ),
    }),
    TableHelper.createCell({
      field: "description",
      headerName: I18nTranslator(translations.receive.description),
      size: "large",
      align: "left",
    }),
    TableHelper.createCell({
      field: "deliveryDate",
      headerName: I18nTranslator(translations.receive.deliveryDate),
      size: "medium",
      align: "left",
      renderCell: ({ value }) => (
        <Typography>{TimeHelper.formatDate(value)}</Typography>
      ),
    }),
    TableHelper.createCell({
      field: "userCreateFullName",
      headerName: I18nTranslator(translations.receive.createBy),
      size: "small",
      align: "left",
    }),
    TableHelper.createCell({
      field: "userWarehouse",
      headerName: I18nTranslator(translations.receive.stocker),
      size: "small",
      align: "left",
    }),
    TableHelper.createCell({
      field: "userReview",
      headerName: I18nTranslator(translations.receive.checker),
      size: "small",
      align: "left",
    }),
  ];
  return (
    <div>
      <Grid container>
        <AppTable<IPrepare>
          title={i18n.t(_t(translations.receive.prepareDocument))}
          loading={action!.includes(
            PrepareActions.getAllPrepareDocuments.requestName
          )}
          data={data}
          columns={COLUMNS}
          hideAddNew
          hideDownload
          hideImport
          onCellClick={onCellClick}
          onSearch={setSearchText}
          onChangePage={_getAllPrepareDocuments}
          removeActionColumn
        />
      </Grid>
    </div>
  );
};

export default PrepareDocument;
